import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { Divider } from "@mui/material";

import { Container } from "../../../components/Container";
import { SplitProgressBar } from "../../../components/SplitProgressBar";
import {
  getBillingBilling,
  getBillingLocationIncreaseComparisonNegativeSum,
  getBillingLocationIncreaseComparisonPositiveSum,
} from "../../../selectors/billing";
import { BillingCalculationFeeChangeChart } from "../BillingCalculationFeeChangeChart";
import { BillingFeeCalculationSummaryItem } from "../BillingFeeCalculationSummaryItem";

import styles from "./BillingCalculationStats.module.scss";

export const BillingCalculationStats = () => {
  const { t } = useTranslation();
  const { avgHouseholdFee, avgHouseholdFeeIncrease, avgResidentFee, avgResidentFeeIncrease } =
    useSelector(getBillingBilling);
  const locationIncreaseComparisonPositiveSum = useSelector(getBillingLocationIncreaseComparisonPositiveSum);
  const locationIncreaseComparisonNegativeSum = useSelector(getBillingLocationIncreaseComparisonNegativeSum);

  return (
    <Container>
      <div className={styles.container}>
        <h4 className={styles.title}>{t("billingCalculationStats.title")}</h4>
        <div className={styles.containerSummary}>
          <BillingFeeCalculationSummaryItem
            label={t("billingCalculationStats.averageFeePerResident")}
            value={avgResidentFee}
            percentChange={avgResidentFeeIncrease}
            reverseNegativeColors
          />
          <BillingFeeCalculationSummaryItem
            label={t("billingCalculationStats.averageFeePerHousehold")}
            value={avgHouseholdFee}
            percentChange={avgHouseholdFeeIncrease}
            reverseNegativeColors
          />
        </div>
        <Divider />
        <BillingCalculationFeeChangeChart />
        <Divider />
        <SplitProgressBar
          leftSegment={{ value: locationIncreaseComparisonPositiveSum, color: "var(--red-600)" }}
          rightSegment={{ value: locationIncreaseComparisonNegativeSum, color: "var(--green)" }}
        />
      </div>
    </Container>
  );
};
